import type { BaseUsecase } from '@usecases/base-usecase';
import type { Team } from '@entities/team';
import type { BusTeamListPayload } from '@main/event-listeners/payloads/bus-team-list.payload';

export interface StoreTeamListRepository {
  addTeam(teams: Team[]): Promise<void>;
  getTeams(): Promise<Team[]>;
}

export interface StoreTeamListEventPublisher {
  publish(from: number): Promise<void>;
}

export interface StoreTeamListUsecase
  extends BaseUsecase<BusTeamListPayload, void> {
  run(req: BusTeamListPayload): Promise<void>;
}

export class StoreTeamList implements StoreTeamListUsecase {
  constructor(
    private repository: StoreTeamListRepository,
    private publisher: StoreTeamListEventPublisher,
  ) {}

  async run(payload: BusTeamListPayload): Promise<void> {
    setTimeout(async () => {
      const teams = payload.searchTeams.items as Team[]; // Get the teams from the payload.
      await this.repository.addTeam(teams); // Persist the teams in the repository.
      // SEARCH_TEAMS paginates via from/limit/total. Fetch the next page only
      // while we have stored fewer teams than the reported total.
      const stored = await this.repository.getTeams();
      if (stored.length < payload.searchTeams.total) {
        await this.publisher.publish(stored.length);
      }
    }, 1000);
  }
}
